export const ADMIN_SCRIPTS_QUERY_KEY = "admin/scripts/";

export type ParamKind = "int" | "str" | "bool" | "choice";

export type ParamValue = string | number | boolean | undefined;

export type ScriptParam = {
  name: string;
  flag: string;
  kind: ParamKind;
  default: ParamValue | null;
  choices: string[] | null;
  help: string;
  destructive: boolean;
  max: number | null;
};

export type Script = {
  name: string;
  label: string;
  description: string;
  danger: "safe" | "destructive";
  params: ScriptParam[];
};

export type RunResponse = { ok: boolean; output: string };

export type ScriptValues = Record<string, ParamValue>;
